(function () {
  var DENSITY_KEY = 'tinkerznest:collection-density';

  function getSection() {
    return document.querySelector('[data-collection-section]');
  }

  function applyStoredDensity() {
    var stored = localStorage.getItem(DENSITY_KEY);
    if (!stored) return;
    document.querySelectorAll('[data-collection-grid]').forEach(function (grid) {
      grid.style.setProperty('--grid-columns', stored);
    });
    document.querySelectorAll('[data-density-value]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-density-value') === stored);
    });
  }

  function buildFacetUrl() {
    var section = getSection();
    var form = document.getElementById('FacetForm');
    var sortSelect = document.querySelector('[data-sort-select]');
    var params = new URLSearchParams();

    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
    }
    if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);

    var base = section.getAttribute('data-collection-url');
    return { display: base + '?' + params.toString(), fetch: base + '?' + params.toString() + '&section_id=' + section.getAttribute('data-section-id') };
  }

  function refreshResults(fetchUrl, displayUrl, append) {
    fetch(fetchUrl)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newResults = doc.querySelector('[data-collection-results]');
        var currentResults = document.querySelector('[data-collection-results]');
        if (!newResults || !currentResults) return;

        if (append) {
          var newGrid = newResults.querySelector('[data-collection-grid]');
          var currentGrid = currentResults.querySelector('[data-collection-grid]');
          if (newGrid && currentGrid) {
            while (newGrid.firstElementChild) currentGrid.appendChild(newGrid.firstElementChild);
          }
          var newPagination = newResults.querySelector('[data-pagination]');
          var currentPagination = currentResults.querySelector('[data-pagination]');
          if (currentPagination) {
            if (newPagination) currentPagination.replaceWith(newPagination);
            else currentPagination.remove();
          }
        } else {
          currentResults.replaceWith(newResults);
        }

        var newFilters = doc.querySelector('[data-filters-panel]');
        var currentFilters = document.querySelector('[data-filters-panel]');
        if (newFilters && currentFilters && !append) currentFilters.replaceWith(newFilters);

        if (displayUrl) window.history.replaceState({}, '', displayUrl);
        applyStoredDensity();
      });
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  var submitFacets = debounce(function () {
    var urls = buildFacetUrl();
    refreshResults(urls.fetch, urls.display, false);
  }, 250);

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-facet-input], [data-sort-select]')) {
      submitFacets();
    }
  });

  document.addEventListener('click', function (event) {
    var densityBtn = event.target.closest('[data-density-value]');
    if (densityBtn) {
      var value = densityBtn.getAttribute('data-density-value');
      localStorage.setItem(DENSITY_KEY, value);
      applyStoredDensity();
      return;
    }

    if (event.target.closest('[data-filter-toggle]')) {
      var panel = document.querySelector('[data-filters-panel]');
      if (!panel) return;
      panel.classList.add('is-open');
      var backdrop = document.createElement('div');
      backdrop.className = 'filter-backdrop';
      backdrop.setAttribute('data-filter-backdrop', '');
      document.body.appendChild(backdrop);
      return;
    }

    if (event.target.closest('[data-filter-close]') || event.target.matches('[data-filter-backdrop]')) {
      var openPanel = document.querySelector('[data-filters-panel]');
      if (openPanel) openPanel.classList.remove('is-open');
      var backdropEl = document.querySelector('[data-filter-backdrop]');
      if (backdropEl) backdropEl.remove();
      return;
    }

    var loadMore = event.target.closest('[data-load-more]');
    if (loadMore) {
      event.preventDefault();
      var section = getSection();
      var nextUrl = loadMore.getAttribute('href') + '&section_id=' + section.getAttribute('data-section-id');
      refreshResults(nextUrl, null, true);
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target.id !== 'FacetForm') return;
    event.preventDefault();
    submitFacets();
  });

  applyStoredDensity();
})();
